'use client';

import { InfiniteMovingCards } from '@/components/ui/infinite-moving-cards';

export function InfiniteMovingCard() {
  return (
    <div className='dark:bg-grid-white/[0.05] relative flex h-[40rem] flex-col items-center justify-center overflow-hidden rounded-md bg-white antialiased dark:bg-black'>
      <InfiniteMovingCards
        items={testimonials}
        direction='right'
        speed='slow'
      />
    </div>
  );
}

const testimonials = [
  {
    key: '1',
    question: 'Increased Revenue & Improved Cash Flow',
    answer: `With our team of certified billers and coders, you can rest assured that each claim is submitted with the utmost accuracy to minimize errors that lead to claim rejections, ensuring quicker payments and expedited cash flow for your practice.`,
  },
  {
    key: '2',
    question: 'Cost Efficiency',
    answer: `Lower your overhead costs by outsourcing. Replace the costs and logistics of salaries, benefits, and in-house training with one, simple expense that is often less costly while giving your practice access to more resources. Maintain scalability as your practice continues to grow, HSMedBilling will allocate the right resources to best accommodate the growing demands of the provider without added internal costs to your practice.`,
  },
  {
    key: '3',
    question: 'Provider Training & Inservice',
    answer: `Keep your office staff to stay up to date with the latest insurance policies and guidelines, with virtual live-training sessions. We also work closely with your team to streamline processes and optimize intake and billing documentation, so that your revenue cycle is always optimized for fast turnaround and operational efficiency.`,
  },
  {
    key: '4',
    question: 'Reduce Administrative Burden',
    answer: `Medical billing and AR Management can be time-consuming and distract providers from patient care. Outsourcing your Billing needs allows providers and their staff to focus on patient care.   Increase efficiency and reduce paperwork, while we handle the complex billing processes.`,
  },
  {
    key: '5',
    question: 'Advanced Technology and Integration',
    answer: (
      <div>
        <ul>
          <li>
            Our team is well trained to work with many EHR and PM software
            systems, like OfficeAlly, TherapyNotes, SimplePractice, AdvancedMD,
            Kareo, RxNT, and many more.
          </li>
          <li>
            {`If your practice isn't currently using an EHR/PM system,
            our team is here to guide you in selecting the ideal
            software tailored to your specific needs. We’ll ensure you
            find a solution that enhances workflow efficiency and
            improves patient care, all while streamlining your
            operations.`}
          </li>
        </ul>
      </div>
    ),
  },
  {
    key: '6',
    question: 'Customized Solutions and Personalization',
    answer: `Whether you're a solo practitioner or part of a multi-location, multi-state practice, we offer tailored Revenue Cycle Management (RCM) and medical billing solutions designed to fit the unique needs of your specialty and practice size.`,
  },
  {
    key: '7',
    question: 'Transparent Reporting and Analytics',
    answer: (
      <div>
        <ul>
          <li>
            <strong>Data-Driven Insights for Optimized Billing:</strong>{' '}
            {`with real-time access to key performance metrics and
            comprehensive analytics. Our RCM medical billing services
            provide valuable insights that allow you to monitor
            billing efficiency, improve revenue cycles, and enhance
            overall financial performance. With clear, actionable
            data, you can make informed decisions to boost your
            practice's profitability.`}
          </li>
          <li>
            <strong>Transparent Reporting:</strong> Gain access to
            comprehensive, easy-to-understand reports detailing claims,
            payments, denials, and other essential financial metrics. Our
            transparent reporting ensures you have the insights needed to make
            informed decisions and optimize your revenue cycle management.
          </li>
        </ul>
      </div>
    ),
  },
];
